<template>
    <div v-if="dictionaryLoaded">
        <form id="artistProfileAccountForm" method="POST" action="/umbraco/api/artistMemberApi/CreateArtistAccount"
            v-on:submit="handleFormSubmit">
            <ArtistProfileAccountForm :mode="vueHelpers.createModeKey" ref="artistProfileAccountForm"
                inputKey="ArtistAccount" />
            <fieldset class="field">
                <legend>
                    {{ dictionary.MemberCreateMemberTypeTitle }}
                </legend>
                <p>{{ dictionary.MemberCreateMemberTypeText }}</p>
                <TabView class="profile-types-tabviews">
                    <TabPanel>
                        <template #header>
                            <div class="p-tabview-title"><span v-if="createStatuses.indexOf('BmmkArtistProfile') != -1">✔ </span>{{ dictionary.MembersCommonBMMKTabTitle }}</div>
                        </template>
                        <fieldset>
                            <legend>{{ dictionary.MembersCreateMemberBMMKHeadline }}</legend>
                            <p>{{ dictionary.MembersCreateMemberBMMKDescription }}</p>
                            <ArtistProfileArtistForm actionType="create" inputKey="BmmkArtistProfile"
                                @createStatusUpdated="handleFormCreateStatusUpdate" />
                        </fieldset>
                    </TabPanel>
                    <TabPanel>
                        <template #header>
                            <div class="p-tabview-title"><span v-if="createStatuses.indexOf('UmmkArtistProfile') != -1">✔ </span>{{ dictionary.MembersCommonUMMKTabTitle }}</div>
                        </template>
                        <fieldset>
                            <legend>{{ dictionary.MembersCreateMemberUMMKHeadline }}</legend>
                            <p>{{ dictionary.MembersCreateMemberUMMKDescription }}</p>
                            <ArtistProfileArtistForm actionType="create" inputKey="UmmkArtistProfile" @createStatusUpdated="handleFormCreateStatusUpdate"
                                :useYoungLabel="true" />
                        </fieldset>
                    </TabPanel>
                    <TabPanel>
                        <template #header>
                            <div class="p-tabview-title"><span v-if="createStatuses.indexOf('UmmkYoungProfile') != -1">✔ </span>{{ dictionary.MembersCommonUMMKYoungTabTitle }}</div>
                        </template>
                        <fieldset>
                            <legend>{{ dictionary.MembersCreateMemberUMMKYoungHeadline }}</legend>
                            <p>{{ dictionary.MembersCreateMemberUMMKYoungDescription }}</p>
                            <ArtistProfileYoungForm actionType="create" inputKey="UmmkYoungProfile" @createStatusUpdated="handleFormCreateStatusUpdate" />
                        </fieldset>
                    </TabPanel>
                </TabView>
            </fieldset>
            <div class="formgrid grid">
                <div class="col-12">
                    <div class="field field-checkbox">
                        <Checkbox inputId="acceptsTerms" name="acceptsTerms" v-model="model.acceptsTerms" :binary="true" />
                        <label for="acceptsTerms">{{ dictionary.MembersCreateMemberDataConsentLabel }}</label>
                    </div>
                </div>
            </div>
            <br />
            <Button type="submit" :disabled="!enableSubmission">{{ dictionary.MembersCreateMemberSubmitButtonText }}</Button>
        </form>
        <Toast position="top-center" />
    </div>
</template>
<script>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import Toast from 'primevue/toast';
import InputText from 'primevue/inputtext';
import ArtistProfileAccountForm from './components/artistProfileAccountForm.vue';
import ArtistProfileArtistForm from './components/artistProfileArtistForm.vue';
import ArtistProfileYoungForm from './components/artistProfileYoungForm.vue';
import ResponsiveImage from "./components/responsiveImage.vue";
import VueHelpers from './vueHelpers';

export default {
    name: "artistProfileSignup",
    components: {
        TabView,
        TabPanel,
        InputText,
        Checkbox,
        Toast,
        Button,
        ArtistProfileAccountForm,
        ArtistProfileArtistForm,
        ArtistProfileYoungForm,
        ResponsiveImage
    },
    data() {
        return {
            vueHelpers: null,
            dictionary: [],
            dictionaryLoaded: false,
            model: {
                acceptsTerms: false
            },
            createStatuses: []
        };
    },
    created() {
        const vm = this;
        vm.vueHelpers = VueHelpers;
        fetch('/umbraco/api/resourcesApi/GetMembersDictionary').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                vm.dictionaryLoaded = true;
            })
            .catch((error) => {
                console.log(error);
                vm.dictionaryLoaded = true;
            });

    },
    computed:{
        enableSubmission: function () {
            return this.createStatuses.length > 0 && !this.$refs.artistProfileAccountForm.v$.$invalid && this.model.acceptsTerms;
            
        }
    },  
    methods: {
        handleFormCreateStatusUpdate(status) {
            if (status.value == true && this.createStatuses.indexOf(status.key) == -1) {
                this.createStatuses.push(status.key);
            } else if (status.value == false) {
                this.createStatuses.pop(status.key);
            }
        },
        handleFormSubmit(e) {
            e.preventDefault();
            const vm = this;
            if (this.enableSubmission) {
                vm.toggleSpinner(true);
                //We have to fix the value of the checkboxes, because Primevue thinks true should be "on"
                const formData = new FormData(e.target);
                for (const pair of formData.entries()) {
                    if (pair[1] == "on") {
                        formData.set(pair[0], true);
                    }
                }
                fetch(e.target.action, {
                    method: e.target.method,
                    headers: {
                        "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                    },
                    body: formData,
                })
                    .then((response) => {
                        if (response.status == 200) {
                            vm.toggleSpinner(false);
                            e.target.reset();
                            vm.$toast.add({ severity: 'success', summary: vm.dictionary.MembersCreateMemberSuccessTitle, detail: vm.dictionary.MembersCreateMemberSuccessText, life: 10000 });
                        } else {
                            const error = new Error("");
                            error.status = response.status;
                            throw error;
                        }
                    })
                    .catch((error) => {
                        vm.$emit("loading", false);
                        vm.toggleSpinner(false);

                        vm.$toast.add({ severity: 'error', summary: vm.dictionary.MembersGeneralErrorTitle, detail: vm.dictionary.MembersGeneralErrorText, life: 10000 });
                    });
            } else if (!this.model.acceptsTerms) {
                vm.$toast.add({ severity: 'error', summary: vm.dictionary.MembersConsentErrorTitle, detail: vm.dictionary.MembersConsentErrorText, life: 10000 });

            } else {
                vm.$toast.add({ severity: 'error', summary: vm.dictionary.MembersCommonInvalidInfoNotificationTitle, detail: vm.dictionary.MembersCommonInvalidInfoNotificationText, life: 10000 });

            }

        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;

            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        }
    }
};
</script>